import React, { useEffect, useMemo, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Heart, MessageCircle, Share2, Bookmark, Send, PenSquare, ShieldCheck, Sparkles, Users, Clock3, Image as ImageIcon, Search, MoreHorizontal, ThumbsUp, CircleAlert, TrendingUp, Flame, Trash2, CheckCircle, } from "lucide-react";
import { db as database, auth } from "./firebase";
import { ref, set, onValue } from "firebase/database";

/**
 * congdong.js
 */

export default function CongDongPage() {
  const [activeTab, setActiveTab] = useState("feed");
  const [query, setQuery] = useState("");
  const [selectedTag, setSelectedTag] = useState("Tất cả");
  const [composerOpen, setComposerOpen] = useState(false);
  const [selectedPostId, setSelectedPostId] = useState(null);
  const [commentDraft, setCommentDraft] = useState("");

  // States cho form viết bài mới
  const [storyTitle, setStoryTitle] = useState("");
  const [storyContent, setStoryContent] = useState("");
  const [storyImage, setStoryImage] = useState("");
  const [storyTag, setStoryTag] = useState("Góc khoe sắc");
  const [storyAnonymous, setStoryAnonymous] = useState(false);

  const [toast, setToast] = useState("");
  const [loadingRealtime, setLoadingRealtime] = useState(true);
  const scrollRef = useRef(null);

  const currentUser = useMemo(() => {
    const user = auth?.currentUser;
    return {
      uid: user?.uid || "guest-user",
      displayName: user?.displayName || "Khách ghé thăm",
      role: user?.email === "admin@yourdomain.com" ? "admin" : "member",
      avatar:
        user?.photoURL ||
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80",
    };
  }, []);

  const isLoggedIn = Boolean(auth?.currentUser);
  const isAdmin = currentUser.role === "admin";

  const tags = ["Tất cả", "Cắm hoa", "Chăm sóc", "Chuyện nghề", "Góc khoe sắc", "Thông báo"];

  const allowedTags = new Set(["Cắm hoa", "Chăm sóc", "Chuyện nghề", "Góc khoe sắc", "Thông báo"]);
  const flowerKeywords = [
    "hoa",
    "bông",
    "cánh hoa",
    "bó hoa",
    "cắm hoa",
    "bình hoa",
    "lẵng hoa",
    "giỏ hoa",
    "vườn hoa",
    "hoa hồng",
    "hoa lan",
    "hoa cúc",
    "hoa ly",
    "hoa sen",
    "hoa mẫu đơn",
    "cẩm tú cầu",
    "baby",
    "đà lạt",
    "florist",
    "flower",
    "bouquet",
  ];

  const isFlowerRelatedText = (value) => {
    const text = String(value || "").toLowerCase();
    return flowerKeywords.some((keyword) => text.includes(keyword));
  };

  const normalizeCommunityPost = (item, fallbackId) => {
    if (!item) return null;

    const post = {
      id: fallbackId || item.id || `post_${Date.now()}`,
      ...item,
    };

    const title = String(post.title || "");
    const content = String(post.content || "");
    const tag = String(post.tag || "");

    const matchesKnownTag = allowedTags.has(tag);
    const matchesFlowerContext =
      isFlowerRelatedText(title) || isFlowerRelatedText(content) || isFlowerRelatedText(tag);

    // Chỉ giữ bài liên quan đến chủ đề hoa / cộng đồng hoa
    if (!matchesKnownTag && !matchesFlowerContext) return null;

    if (!post.tag || post.tag === "Tất cả") post.tag = "Góc khoe sắc";

    return post;
  };

  const demoApproved = [
    {
      id: "p1",
      author: "Lan Anh",
      avatar:
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=200&q=80",
      title: "Bí quyết giữ hoa hồng tươi lâu trong thời tiết nắng nóng",
      content:
        "Dạo này Sài Gòn nắng gắt quá, hoa nhập về rất dễ héo nếu không cẩn thận. Mình thường hay thêm một chút xíu đường và vài giọt chanh vào nước cắm. Các bạn chủ tiệm khác có tips nào hay hơn không, chia sẻ cùng mình nhé!",
      tag: "Chăm sóc",
      image:
        "https://images.unsplash.com/photo-1519378058457-4c29a0a2efac?auto=format&fit=crop&w=1400&q=80",
      createdAt: "2026-05-29T08:30:00.000Z",
      approved: true,
      featured: true,
      likes: 124,
      hearts: 78,
      comments: 16,
      shares: 11,
      saved: false,
      userReaction: null,
      topComment:
        "Nước rửa chén loại nhẹ nhỏ 1 giọt vào cũng chống thối thân hoa cực tốt đó bạn ơi.",
      commentsList: [
        { id: "c1", author: "An", text: "Mình toàn dùng gói dưỡng hoa mua sẵn cho tiện." },
        { id: "c2", author: "Vy", text: "Cảm ơn tips của bạn, để mai mình thử nghiệm luôn." },
      ],
    },
    {
      id: "p2",
      author: "Tiệm Hoa Mộc",
      avatar:
        "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80",
      title: "Chút dịu dàng của Cẩm Tú Cầu sáng nay",
      content:
        "Góc nhỏ tiệm mình sáng nay đón đợt cẩm tú cầu Đà Lạt mới về. Màu xanh pastel nhìn mát mắt thật sự. Mọi người thích mix cẩm tú cầu với hoa gì nhất để bó hoa trông bồng bềnh và sang trọng?",
      tag: "Góc khoe sắc",
      image:
        "https://images.unsplash.com/photo-1457089328109-e5d9bd499191?auto=format&fit=crop&w=1400&q=80",
      createdAt: "2026-05-28T14:10:00.000Z",
      approved: true,
      featured: false,
      likes: 89,
      hearts: 103,
      comments: 24,
      shares: 7,
      saved: true,
      userReaction: "heart",
      topComment: "Mix với baby trắng hoặc hồng Ohara là đỉnh nhất luôn shop.",
      commentsList: [
        {
          id: "c1",
          author: "Hà",
          text: "Hoa đợt này cánh to đẹp quá, mình mới đặt 1 bó chiều giao nha.",
        },
      ],
    },
  ];

  const demoPending = [
    {
      id: "q1",
      author: currentUser.displayName,
      avatar: currentUser.avatar,
      title: "Tìm nguồn sỉ hoa lá phụ uy tín",
      content:
        "Mình mới mở tiệm nên đang cần tìm vườn hoặc đầu mối sỉ lá bạc, cỏ đồng tiền và hoa baby nhập khẩu. Mọi người ai có mối quen cho mình xin thông tin với ạ.",
      tag: "Chuyện nghề",
      image: "",
      createdAt: new Date().toISOString(),
      approved: false,
      likes: 0,
      hearts: 0,
      comments: 0,
      shares: 0,
      saved: false,
      userReaction: null,
      commentsList: [],
    },
  ];

  const [posts, setPosts] = useState(
    demoApproved.map((post) => normalizeCommunityPost(post)).filter(Boolean)
  );
  const [pendingPosts, setPendingPosts] = useState(
    demoPending.map((post) => normalizeCommunityPost(post)).filter(Boolean)
  );

  const normalizePostArray = (snapValue) => {
    if (!snapValue) return [];

    const rawArray = Array.isArray(snapValue)
      ? snapValue.filter(Boolean)
      : Object.entries(snapValue).map(([id, item]) => ({ id, ...item }));

    return rawArray.map((item) => normalizeCommunityPost(item)).filter(Boolean);
  };

  useEffect(() => {
    const rootRef = ref(database, "community");

    const unsubscribe = onValue(rootRef, (snapshot) => {
      const data = snapshot.val();

      const approved = normalizePostArray(data?.approvedPosts);
      const pending = normalizePostArray(data?.pendingPosts);

      if (approved.length > 0) {
        setPosts(
          approved.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
      } else {
        setPosts(demoApproved.map((post) => normalizeCommunityPost(post)).filter(Boolean));
      }

      if (pending.length > 0) {
        setPendingPosts(
          pending.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        );
      } else {
        setPendingPosts(demoPending.map((post) => normalizeCommunityPost(post)).filter(Boolean));
      }

      setLoadingRealtime(false);
    });

    return () => unsubscribe();
  }, []);

  const allVisiblePosts = useMemo(() => {
    const source = activeTab === "pending" ? pendingPosts : posts;

    return source.filter((post) => {
      const safeTitle = String(post?.title || "").toLowerCase();
      const safeContent = String(post?.content || "").toLowerCase();
      const safeAuthor = String(post?.author || "").toLowerCase();
      const safeTag = String(post?.tag || "");

      const matchQuery =
        safeTitle.includes(query.toLowerCase()) ||
        safeContent.includes(query.toLowerCase()) ||
        safeAuthor.includes(query.toLowerCase());

      const matchTag = selectedTag === "Tất cả" || safeTag === selectedTag;
      const matchTab = activeTab === "pending" ? !post.approved : true;

      return matchQuery && matchTag && matchTab;
    });
  }, [activeTab, posts, pendingPosts, query, selectedTag]);

  const approvedCount = posts.filter((p) => p.approved).length;
  const pendingCount = pendingPosts.length;

  const totalEngagement = posts.reduce(
    (sum, p) => sum + (p.likes || 0) + (p.hearts || 0) + (p.comments || 0) + (p.shares || 0),
    0
  );

  const trendingTopics = [
    { label: "#hoa_hồng_ngoại", count: 128 },
    { label: "#mẹo_chăm_hoa", count: 94 },
    { label: "#hoa_cưới_2026", count: 76 },
    { label: "#gốc_tâm_sự_nghề", count: 63 },
  ];

  const quickRules = [
    "Chia sẻ ảnh hoa tự chụp, sắc nét.",
    "Bài mới sẽ được admin duyệt trước khi hiển thị.",
    "Cùng xây dựng cộng đồng yêu hoa văn minh.",
  ];

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => setToast(""), 2200);
    return () => clearTimeout(timer);
  }, [toast]);

  useEffect(() => {
    if (selectedPostId && scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [selectedPostId]);

  const showToast = (message) => setToast(message);

  const getApprovedRef = (postId) => ref(database, `community/approvedPosts/${postId}`);
  const getPendingRef = (postId) => ref(database, `community/pendingPosts/${postId}`);

  const syncApprovedPost = async (post) => {
    await set(getApprovedRef(post.id), post);
  };

  const syncPendingPost = async (post) => {
    await set(getPendingRef(post.id), post);
  };

  const removePendingPost = async (postId) => {
    await set(getPendingRef(postId), null);
  };

  const removeApprovedPost = async (postId) => {
    await set(getApprovedRef(postId), null);
  };

  const handleSubmitStory = async (e) => {
    e.preventDefault();

    if (!isLoggedIn) {
      showToast("Bạn cần đăng nhập để đăng bài.");
      return;
    }

    if (!storyTitle.trim() || !storyContent.trim()) {
      showToast("Vui lòng nhập tiêu đề và nội dung bài viết.");
      return;
    }

    const newPost = {
      id: `post_${Date.now()}`,
      author: storyAnonymous ? "Thành viên ẩn danh" : currentUser.displayName,
      avatar: currentUser.avatar,
      title: storyTitle.trim(),
      content: storyContent.trim(),
      tag: storyTag,
      image: storyImage.trim(),
      createdAt: new Date().toISOString(),
      approved: false,
      featured: false,
      likes: 0,
      hearts: 0,
      comments: 0,
      shares: 0,
      saved: false,
      userReaction: null,
      commentsList: [],
    };

    try {
      await syncPendingPost(newPost);
      setStoryTitle("");
      setStoryContent("");
      setStoryImage("");
      setStoryTag("Góc khoe sắc");
      setStoryAnonymous(false);
      setActiveTab("pending");
      setComposerOpen(false);
      showToast("Bài đã gửi để admin duyệt.");
    } catch (error) {
      console.error("Lỗi lưu bài pending:", error);
      showToast("Không thể gửi bài lúc này.");
    }
  };

  const approvePost = async (postId) => {
    const post = pendingPosts.find((p) => p.id === postId);
    if (!post) return;

    const approvedPost = {
      ...post,
      approved: true,
      approvedAt: new Date().toISOString(),
    };

    try {
      await syncApprovedPost(approvedPost);
      await removePendingPost(postId);
      showToast("Admin đã duyệt bài.");
    } catch (error) {
      console.error("Lỗi duyệt bài:", error);
      showToast("Không thể duyệt bài lúc này.");
    }
  };

  const unpublishPost = async (postId) => {
    try {
      await removeApprovedPost(postId);
      showToast("Đã gỡ bài viết khỏi cộng đồng.");
    } catch (error) {
      console.error("Lỗi gỡ bài:", error);
      showToast("Không thể gỡ bài lúc này.");
    }
  };

  const updateApprovedPostLocal = async (postId, updater) => {
    const nextPost = posts.find((p) => p.id === postId);
    if (!nextPost) return;

    const patched = updater({ ...nextPost });

    setPosts((prev) => prev.map((p) => (p.id === postId ? patched : p)));
    await syncApprovedPost(patched);
  };

  const toggleReaction = async (postId, reaction) => {
    if (!isLoggedIn) {
      showToast("Vui lòng đăng nhập để tương tác.");
      return;
    }

    try {
      await updateApprovedPostLocal(postId, (post) => {
        const prevReaction = post.userReaction;

        if (prevReaction === reaction) {
          post.userReaction = null;
          if (reaction === "like") post.likes = Math.max(0, (post.likes || 0) - 1);
          if (reaction === "heart") post.hearts = Math.max(0, (post.hearts || 0) - 1);
          showToast(reaction === "like" ? "Đã gỡ like." : "Đã gỡ tim.");
        } else {
          if (prevReaction === "like") post.likes = Math.max(0, (post.likes || 0) - 1);
          if (prevReaction === "heart") post.hearts = Math.max(0, (post.hearts || 0) - 1);

          post.userReaction = reaction;

          if (reaction === "like") post.likes = (post.likes || 0) + 1;
          if (reaction === "heart") post.hearts = (post.hearts || 0) + 1;

          showToast(reaction === "like" ? "Bạn đã like bài viết." : "Bạn đã thả tim.");
        }

        return post;
      });
    } catch (error) {
      console.error("Lỗi tương tác bài viết:", error);
      showToast("Không thể cập nhật tương tác.");
    }
  };

  const toggleSave = async (postId) => {
    if (!isLoggedIn) {
      showToast("Vui lòng đăng nhập để lưu bài.");
      return;
    }

    try {
      await updateApprovedPostLocal(postId, (post) => {
        post.saved = !post.saved;
        showToast(post.saved ? "Đã lưu bài." : "Đã bỏ lưu.");
        return post;
      });
    } catch (error) {
      console.error("Lỗi lưu bài:", error);
      showToast("Không thể lưu bài.");
    }
  };

  const handleShare = async (post) => {
    const url = `${window.location.origin}/congdong/${post.id}`;

    try {
      if (navigator.share) {
        await navigator.share({
          title: post.title,
          text: post.content,
          url,
        });
      } else {
        await navigator.clipboard.writeText(url);
      }

      await updateApprovedPostLocal(post.id, (p) => {
        p.shares = (p.shares || 0) + 1;
        return p;
      });

      showToast("Đã sao chép link chia sẻ.");
    } catch {
      showToast("Không thể chia sẻ lúc này.");
    }
  };

  const handleComment = async (postId) => {
    if (!isLoggedIn) {
      showToast("Vui lòng đăng nhập để bình luận.");
      return;
    }

    if (!commentDraft.trim()) {
      showToast("Nhập nội dung bình luận trước.");
      return;
    }

    const nextComment = {
      id: `c_${Date.now()}`,
      author: currentUser.displayName,
      text: commentDraft.trim(),
      createdAt: new Date().toISOString(),
    };

    try {
      await updateApprovedPostLocal(postId, (post) => {
        post.comments = (post.comments || 0) + 1;
        post.commentsList = [nextComment, ...(post.commentsList || [])];
        return post;
      });

      setCommentDraft("");
      showToast("Đã đăng bình luận.");
    } catch (error) {
      console.error("Lỗi bình luận:", error);
      showToast("Không thể đăng bình luận.");
    }
  };

  const formatDate = (iso) => {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return "";

    return new Intl.DateTimeFormat("vi-VN", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }).format(date);
  };

  const displayedStats = [
    { label: "Bài đã duyệt", value: approvedCount, icon: <ShieldCheck size={16} /> },
    { label: "Bài chờ duyệt", value: pendingCount, icon: <Clock3 size={16} /> },
    { label: "Lượt tương tác", value: totalEngagement, icon: <Sparkles size={16} /> },
    { label: "Thành viên online", value: 284, icon: <Users size={16} /> },
  ];

  return (
    <div className="community-shell">
      <style>{`
        * {
          box-sizing: border-box;
        }

        .community-shell {
          min-height: 100vh;
          background: #FCFBF8;
          background-image:
            radial-gradient(circle at 15% 10%, rgba(203, 161, 83, 0.05) 0%, transparent 40%),
            radial-gradient(circle at 85% 90%, rgba(203, 161, 83, 0.04) 0%, transparent 40%);
          color: #2C2C2C;
          overflow-x: hidden;
          font-family: 'Montserrat', system-ui, -apple-system, sans-serif;
        }

        .community-hero {
          position: relative;
          padding: 120px 6% 60px;
          background: linear-gradient(135deg, #1C1917 0%, #0C0A09 100%);
          color: #fff;
          overflow: hidden;
          border-bottom: 1px solid rgba(203, 161, 83, 0.2);
        }

        .community-hero::before {
          content: "";
          position: absolute;
          inset: 0;
          background-image: radial-gradient(rgba(203, 161, 83, 0.15) 1px, transparent 1px);
          background-size: 32px 32px;
          opacity: 0.3;
          pointer-events: none;
        }

        .community-hero-inner {
          position: relative;
          z-index: 2;
          display: grid;
          grid-template-columns: 1.2fr 0.8fr;
          gap: 40px;
          align-items: center;
          max-width: 1400px;
          margin: 0 auto;
        }

        .eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 8px 16px;
          border: 1px solid rgba(203, 161, 83, 0.4);
          border-radius: 999px;
          background: rgba(203, 161, 83, 0.1);
          backdrop-filter: blur(18px);
          font-size: 11px;
          letter-spacing: 2.5px;
          text-transform: uppercase;
          color: #E8D8B0;
          width: fit-content;
        }

        .hero-title {
          font-family: "Cormorant Garamond", serif;
          font-size: clamp(38px, 5vw, 64px);
          line-height: 1.1;
          letter-spacing: 0.5px;
          margin: 24px 0 20px;
          max-width: 760px;
          color: #FDFCF8;
          font-weight: 500;
        }

        .hero-title i {
          font-family: "Pinyon Script", cursive;
          font-style: normal;
          font-size: 1.3em;
          color: #CBA153;
          font-weight: 400;
        }

        .hero-desc {
          max-width: 600px;
          color: rgba(253, 252, 248, 0.7);
          font-size: 15px;
          line-height: 1.9;
          margin: 0;
          font-weight: 300;
        }

        .hero-actions {
          display: flex;
          gap: 14px;
          flex-wrap: wrap;
          margin-top: 36px;
        }

        .hero-chip {
          padding: 14px 24px;
          border-radius: 999px;
          border: 1px solid rgba(253, 252, 248, 0.2);
          background: rgba(255, 255, 255, 0.03);
          color: #fff;
          font-size: 13px;
          letter-spacing: 0.8px;
          cursor: pointer;
          transition: all 0.3s ease;
          text-transform: uppercase;
        }

        .hero-chip:hover {
          background: rgba(203, 161, 83, 0.15);
          border-color: rgba(203, 161, 83, 0.5);
        }

        .hero-side-card {
          border-radius: 24px;
          padding: 32px;
          background: rgba(255,255,255,0.03);
          border: 1px solid rgba(203, 161, 83, 0.2);
          backdrop-filter: blur(24px);
          -webkit-backdrop-filter: blur(24px);
          box-shadow: 0 24px 60px rgba(0,0,0,0.3);
        }

        .side-stat-row {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
        }

        .side-stat {
          padding: 20px 18px;
          border-radius: 16px;
          background: rgba(255,255,255,0.02);
          border: 1px solid rgba(255,255,255,0.05);
        }

        .side-stat strong {
          display: block;
          font-size: 28px;
          margin-top: 10px;
          font-family: "Cormorant Garamond", serif;
          font-weight: 400;
          color: #CBA153;
        }

        .section-wrap {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 6% 90px;
        }

        .stats-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
          margin-top: -36px;
          position: relative;
          z-index: 3;
        }

        .stat-card {
          padding: 24px 24px;
          border-radius: 20px;
          background: rgba(252, 251, 248, 0.9);
          border: 1px solid rgba(203, 161, 83, 0.2);
          box-shadow: 0 16px 40px rgba(0,0,0,0.04);
          backdrop-filter: blur(16px);
        }

        .stat-label {
          display: flex;
          align-items: center;
          gap: 10px;
          color: #8C8C8C;
          font-size: 11px;
          text-transform: uppercase;
          letter-spacing: 2px;
        }

        .stat-label svg {
          color: #CBA153;
        }

        .stat-value {
          margin-top: 16px;
          font-family: "Cormorant Garamond", serif;
          font-size: clamp(32px, 4vw, 48px);
          line-height: 1;
          color: #1A1A1A;
        }

        .layout-grid {
          display: grid;
          grid-template-columns: minmax(0, 1.35fr) minmax(320px, 0.65fr);
          gap: 40px;
          margin-top: 40px;
        }

        .panel {
          border-radius: 24px;
          background: #FFFFFF;
          border: 1px solid rgba(203, 161, 83, 0.15);
          box-shadow: 0 20px 50px rgba(0,0,0,0.03);
          overflow: hidden;
        }

        .panel-head {
          padding: 32px 32px 0;
        }

        .panel-title {
          font-family: "Cormorant Garamond", serif;
          font-size: 36px;
          font-weight: 500;
          letter-spacing: 0.5px;
          margin: 0;
          color: #1A1A1A;
        }

        .panel-sub {
          margin: 12px 0 0;
          color: #6C6C6C;
          font-size: 14px;
          line-height: 1.8;
          font-weight: 300;
        }

        .toolbar {
          display: flex;
          gap: 16px;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          padding: 24px 32px 0;
        }

        .search-box {
          flex: 1;
          min-width: 240px;
          display: flex;
          align-items: center;
          gap: 12px;
          background: rgba(250, 249, 246, 1);
          border: 1px solid rgba(203, 161, 83, 0.2);
          padding: 14px 18px;
          border-radius: 999px;
          transition: border-color 0.3s ease;
        }

        .search-box:focus-within {
          border-color: #CBA153;
          background: #fff;
        }

        .search-box input {
          width: 100%;
          border: none;
          outline: none;
          background: transparent;
          font-size: 14px;
          color: #2C2C2C;
        }

        .filter-chip-row {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
          padding: 20px 32px 28px;
        }

        .filter-chip-btn {
          border: 1px solid rgba(203, 161, 83, 0.2);
          background: transparent;
          color: #595959;
          padding: 10px 20px;
          border-radius: 999px;
          font-size: 13px;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .filter-chip-btn:hover {
          background: rgba(203, 161, 83, 0.05);
        }

        .filter-chip-btn.active {
          background: #1C1C1C;
          color: #FDFCF8;
          border-color: #1C1C1C;
        }

        .composer {
          margin: 0 32px 32px;
          border-radius: 20px;
          background: #FAF8F5;
          border: 1px solid rgba(203, 161, 83, 0.3);
          overflow: hidden;
        }

        .composer-head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 14px;
          padding: 24px 24px 0;
        }

        .composer-title {
          display: flex;
          align-items: center;
          gap: 12px;
          font-weight: 500;
          color: #1A1A1A;
          font-family: "Cormorant Garamond", serif;
          font-size: 22px;
        }

        .composer-toggle {
          border: none;
          background: rgba(0,0,0,0.04);
          padding: 10px;
          border-radius: 50%;
          cursor: pointer;
          transition: background 0.2s;
        }

        .composer-body {
          padding: 24px;
        }

        .composer-grid {
          display: grid;
          grid-template-columns: 1.2fr 0.8fr;
          gap: 24px;
        }

        .composer textarea,
        .composer input,
        .composer select {
          width: 100%;
          border-radius: 12px;
          border: 1px solid rgba(203, 161, 83, 0.2);
          background: #fff;
          padding: 16px 18px;
          font-size: 14px;
          outline: none;
          font-family: inherit;
          transition: border-color 0.3s;
        }

        .composer textarea:focus,
        .composer input:focus {
          border-color: #CBA153;
        }

        .composer textarea {
          min-height: 180px;
          resize: vertical;
          line-height: 1.8;
        }

        .composer-actions {
          display: flex;
          justify-content: space-between;
          gap: 12px;
          flex-wrap: wrap;
          margin-top: 20px;
          align-items: center;
          border-top: 1px solid rgba(203, 161, 83, 0.15);
          padding-top: 20px;
        }

        .composer-left-actions,
        .composer-right-actions {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
          align-items: center;
        }

        .mini-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          border: 1px solid rgba(203, 161, 83, 0.2);
          background: #fff;
          padding: 12px 20px;
          border-radius: 999px;
          font-size: 13px;
          cursor: pointer;
          transition: all 0.2s;
          color: #2C2C2C;
        }

        .mini-btn:hover {
          background: #FAF8F5;
        }

        .primary-btn {
          background: #1C1C1C;
          color: #fff;
          border-color: #1C1C1C;
        }

        .primary-btn:hover {
          background: #333;
        }

        .feed-list {
          padding: 0 32px 32px;
          display: grid;
          gap: 32px;
        }

        .post-card {
          overflow: hidden;
          border-radius: 20px;
          background: #fff;
          border: 1px solid rgba(203, 161, 83, 0.15);
          box-shadow: 0 12px 30px rgba(0,0,0,0.02);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .post-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.05);
        }

        .post-hero {
          position: relative;
          min-height: 320px;
          background: #1A1A1A;
          overflow: hidden;
        }

        .post-hero img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          opacity: 0.9;
        }

        .post-badge {
          position: absolute;
          top: 20px;
          left: 20px;
          padding: 8px 16px;
          border-radius: 999px;
          background: rgba(255,255,255,0.95);
          font-size: 11px;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: #1A1A1A;
          font-weight: 500;
        }

        .post-body {
          padding: 32px;
        }

        .post-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
        }

        .author-row {
          display: flex;
          align-items: center;
          gap: 14px;
        }

        .avatar {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #E8D8B0;
          padding: 2px;
        }

        .author-name {
          font-weight: 500;
          font-size: 15px;
          color: #1A1A1A;
        }

        .post-meta {
          color: #8C8C8C;
          font-size: 12px;
          margin-top: 4px;
          letter-spacing: 0.5px;
        }

        .more-btn {
          border: none;
          background: transparent;
          cursor: pointer;
          padding: 10px;
          border-radius: 50%;
          color: #8C8C8C;
          transition: background 0.2s;
        }

        .more-btn:hover {
          background: #FAF8F5;
        }

        .post-title {
          font-family: "Cormorant Garamond", serif;
          font-size: 34px;
          line-height: 1.2;
          margin: 20px 0 14px;
          font-weight: 500;
          color: #1A1A1A;
        }

        .post-content {
          font-size: 15px;
          line-height: 2;
          color: #4A4A4A;
          margin: 0;
          white-space: pre-line;
          font-weight: 300;
        }

        .top-comment-box {
          margin-top: 24px;
          padding: 20px;
          border-radius: 12px;
          background: rgba(203, 161, 83, 0.04);
          border-left: 2px solid #CBA153;
          color: #555;
          font-style: italic;
          font-family: "Cormorant Garamond", serif;
          font-size: 18px;
        }

        .post-stats {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          flex-wrap: wrap;
          margin-top: 32px;
          padding-top: 24px;
          border-top: 1px solid rgba(203, 161, 83, 0.15);
        }

        .post-counts {
          display: flex;
          gap: 16px;
          flex-wrap: wrap;
          color: #8C8C8C;
          font-size: 13px;
        }

        .post-actions {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }

        .action-pill {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 10px 16px;
          border: 1px solid transparent;
          border-radius: 999px;
          background: #FAF8F5;
          cursor: pointer;
          font-size: 13px;
          color: #4A4A4A;
          transition: all 0.2s ease;
        }

        .action-pill:hover {
          background: #F0EBE1;
        }

        .action-pill.active-like {
          background: #1C1C1C;
          color: #fff;
        }

        .action-pill.active-heart {
          background: #CBA153;
          color: #fff;
        }

        .action-pill.active-save {
          border-color: #CBA153;
          color: #CBA153;
          background: transparent;
        }

        .comment-box {
          margin-top: 24px;
          display: grid;
          gap: 16px;
          padding-top: 24px;
          border-top: 1px dashed rgba(203, 161, 83, 0.2);
        }

        .comment-box textarea {
          width: 100%;
          min-height: 100px;
          border-radius: 12px;
          border: 1px solid rgba(203, 161, 83, 0.2);
          padding: 16px;
          resize: vertical;
          font-size: 14px;
          outline: none;
          background: #FAF8F5;
          font-family: inherit;
        }

        .comment-box textarea:focus {
          border-color: #CBA153;
          background: #fff;
        }

        .comment-thread {
          margin-top: 16px;
          display: grid;
          gap: 12px;
        }

        .comment-item {
          padding: 16px;
          border-radius: 12px;
          background: rgba(250, 248, 245, 0.6);
          border: 1px solid rgba(203, 161, 83, 0.1);
        }

        .comment-author {
          font-weight: 500;
          font-size: 13px;
          margin-bottom: 6px;
          color: #1A1A1A;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .comment-text {
          font-size: 14px;
          color: #4A4A4A;
          line-height: 1.8;
          font-weight: 300;
        }

        .sidebar {
          display: grid;
          gap: 24px;
          align-content: start;
        }

        .sidebar-card {
          border-radius: 24px;
          background: #FFFFFF;
          border: 1px solid rgba(203, 161, 83, 0.15);
          box-shadow: 0 20px 40px rgba(0,0,0,0.02);
          padding: 32px;
        }

        .sidebar-title {
          font-family: "Cormorant Garamond", serif;
          font-size: 28px;
          margin: 0 0 16px;
          font-weight: 500;
          color: #1A1A1A;
        }

        .sidebar-list {
          display: grid;
          gap: 12px;
          margin-top: 20px;
        }

        .trend-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 12px;
          padding: 14px 0;
          border-bottom: 1px solid rgba(203, 161, 83, 0.15);
          font-size: 14px;
          color: #2C2C2C;
        }

        .trend-row:last-child {
          border-bottom: none;
        }

        .guideline {
          display: grid;
          gap: 12px;
          margin-top: 16px;
        }

        .guide-item {
          padding: 14px 16px;
          border-radius: 12px;
          background: #FAF8F5;
          font-size: 13px;
          line-height: 1.8;
          color: #595959;
          border-left: 2px solid #E8D8B0;
        }

        .approval-panel {
          margin: 0 32px 32px;
          border-radius: 20px;
          padding: 32px;
          border: 1px solid rgba(203, 161, 83, 0.4);
          background: #fff;
        }

        .approval-head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 16px;
          flex-wrap: wrap;
          margin-bottom: 24px;
          padding-bottom: 16px;
          border-bottom: 1px solid rgba(203, 161, 83, 0.15);
        }

        .approval-row {
          display: grid;
          gap: 16px;
        }

        .pending-card {
          display: grid;
          gap: 12px;
          padding: 20px;
          border-radius: 16px;
          background: #FAF8F5;
          border: 1px solid rgba(203, 161, 83, 0.2);
          box-shadow: 0 4px 12px rgba(0,0,0,0.02);
        }

        .pending-top {
          display: flex;
          justify-content: space-between;
          gap: 16px;
          flex-wrap: wrap;
          align-items: flex-start;
        }

        .pending-title {
          font-family: "Cormorant Garamond", serif;
          font-weight: 600;
          font-size: 20px;
          color: #1A1A1A;
        }

        .pending-actions {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }

        .empty-state {
          padding: 60px 20px;
          text-align: center;
          color: #8C8C8C;
        }

        .empty-state svg {
          color: #CBA153;
          margin-bottom: 16px;
        }

        .empty-state h3 {
          font-family: "Cormorant Garamond", serif;
          font-size: 32px;
          margin: 0 0 12px;
          color: #1A1A1A;
          font-weight: 500;
        }

        .toast {
          position: fixed;
          top: 84px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 9999;
          padding: 16px 24px;
          border-radius: 999px;
          background: rgba(28, 28, 28, 0.95);
          color: #FDFCF8;
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.2);
          font-size: 14px;
          letter-spacing: 0.5px;
        }

        .loading-pill {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 10px 16px;
          border-radius: 999px;
          background: rgba(203, 161, 83, 0.1);
          font-size: 12px;
          color: #CBA153;
          border: 1px solid rgba(203, 161, 83, 0.2);
        }

        @media (max-width: 1100px) {
          .community-hero-inner,
          .layout-grid {
            grid-template-columns: 1fr;
          }

          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 768px) {
          .community-hero {
            padding: 100px 5% 40px;
          }

          .section-wrap {
            padding: 0 5% 60px;
          }

          .stats-grid {
            grid-template-columns: 1fr;
            margin-top: -24px;
          }

          .panel-head,
          .toolbar,
          .filter-chip-row,
          .composer,
          .feed-list,
          .approval-panel {
            margin-left: 16px;
            margin-right: 16px;
            padding-left: 20px;
            padding-right: 20px;
          }

          .composer {
            margin-left: 16px;
            margin-right: 16px;
          }

          .composer-grid {
            grid-template-columns: 1fr;
          }

          .post-title {
            font-size: 28px;
          }

          .sidebar {
            margin-top: 20px;
          }
        }
      `}</style>

      {/* Toast Notification */}
      <AnimatePresence>
        {toast && (
          <motion.div
            className="toast"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
          >
            {toast}
          </motion.div>
        )}
      </AnimatePresence>

      <section className="community-hero">
        <div className="community-hero-inner">
          <div>
            <div className="eyebrow">
              <Sparkles size={14} /> Giao Lưu & Cảm Hứng
            </div>
            <h1 className="hero-title">
              Nơi chia sẻ <i>tình yêu hoa</i>, lan tỏa cái đẹp.
            </h1>
            <p className="hero-desc">
              Không gian để khách hàng, chủ tiệm và những người yêu hoa cỏ lưu giữ khoảnh khắc,
              kết nối và xây dựng một cộng đồng ngát hương, sống động theo thời gian thực.
            </p>
            <div className="hero-actions">
              <button className="hero-chip" onClick={() => setActiveTab("feed")}>
                Góc khoe sắc
              </button>
              <button
                className="hero-chip"
                onClick={() => setComposerOpen(true)}
                style={{ background: "#CBA153", color: "#fff", borderColor: "#CBA153" }}
              >
                Chia sẻ ngay
              </button>
            </div>
          </div>

          <motion.div
            className="hero-side-card"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
              <div>
                <div style={{ fontSize: 11, letterSpacing: 2, textTransform: "uppercase", color: "rgba(255,255,255,0.5)" }}>
                  Overview
                </div>
                <div style={{ fontFamily: "Cormorant Garamond, serif", fontSize: 32, marginTop: 6, color: "#FDFCF8" }}>
                  Dấu ấn cộng đồng
                </div>
              </div>
              <ShieldCheck size={24} color="#CBA153" />
            </div>

            <div className="side-stat-row">
              <div className="side-stat">
                <div style={{ fontSize: 12, color: "rgba(255,255,255,0.6)" }}>Bản thảo chờ</div>
                <strong>{pendingCount}</strong>
              </div>
              <div className="side-stat">
                <div style={{ fontSize: 12, color: "rgba(255,255,255,0.6)" }}>Tác phẩm</div>
                <strong>{approvedCount}</strong>
              </div>
              <div className="side-stat">
                <div style={{ fontSize: 12, color: "rgba(255,255,255,0.6)" }}>Lượt tương tác</div>
                <strong>{totalEngagement}</strong>
              </div>
              <div className="side-stat">
                <div style={{ fontSize: 12, color: "rgba(255,255,255,0.6)" }}>Thành viên</div>
                <strong>284</strong>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="section-wrap">
        <div className="stats-grid">
          {displayedStats.map((item, index) => (
            <motion.div
              key={item.label}
              className="stat-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              whileHover={{ y: -6 }}
            >
              <div className="stat-label">
                {item.icon} {item.label}
              </div>
              <div className="stat-value">{item.value}</div>
            </motion.div>
          ))}
        </div>

        <div className="layout-grid" ref={scrollRef}>
          <motion.div 
            className="panel"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="panel-head">
              <h2 className="panel-title">Câu chuyện từ khách hàng</h2>
              <p className="panel-sub">
                Dạo quanh vườn hoa ý tưởng. Các bài viết sẽ được ban quản trị duyệt trước khi xuất bản
                để đảm bảo chất lượng.
              </p>

              {loadingRealtime && (
                <div style={{ marginTop: 16 }}>
                  <span className="loading-pill">
                    <Flame size={14} /> Đang đồng bộ dữ liệu...
                  </span>
                </div>
              )}
            </div>

            <div className="toolbar">
              <div className="search-box">
                <Search size={16} color="#8C8C8C" />
                <input
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="Tìm kiếm kinh nghiệm cắm hoa, tác giả..."
                />
              </div>

              <button className="mini-btn" onClick={() => setComposerOpen((s) => !s)}>
                <PenSquare size={16} /> {composerOpen ? "Đóng form" : "Đăng bài"}
              </button>
            </div>

            <div className="filter-chip-row">
              {tags.map((tag) => (
                <button
                  key={tag}
                  className={`filter-chip-btn ${selectedTag === tag ? "active" : ""}`}
                  onClick={() => setSelectedTag(tag)}
                >
                  {tag}
                </button>
              ))}
            </div>

            {/* Bổ sung phần Tab hiển thị cho Admin ngay trước danh sách feed */}
            {isAdmin && (
              <div className="filter-chip-row" style={{ paddingTop: 0, paddingBottom: 16 }}>
                <button
                  className={`filter-chip-btn ${activeTab === "feed" ? "active" : ""}`}
                  onClick={() => setActiveTab("feed")}
                >
                  <CheckCircle size={14} style={{ display: "inline", marginRight: 6, verticalAlign: "middle" }} />
                  Đã duyệt
                </button>
                <button
                  className={`filter-chip-btn ${activeTab === "pending" ? "active" : ""}`}
                  onClick={() => setActiveTab("pending")}
                >
                  <Clock3 size={14} style={{ display: "inline", marginRight: 6, verticalAlign: "middle" }} />
                  Chờ duyệt ({pendingCount})
                </button>
              </div>
            )}

            <AnimatePresence>
              {composerOpen && (
                <motion.form
                  className="composer"
                  onSubmit={handleSubmitStory}
                  initial={{ opacity: 0, height: 0, marginBottom: 0 }}
                  animate={{ opacity: 1, height: "auto", marginBottom: 32 }}
                  exit={{ opacity: 0, height: 0, marginBottom: 0 }}
                  transition={{ duration: 0.4, ease: "easeInOut" }}
                  style={{ overflow: "hidden" }}
                >
                  <div className="composer-head">
                    <div className="composer-title">
                      <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#CBA153" }} />
                      Chia sẻ khoảnh khắc
                    </div>

                    <button
                      type="button"
                      className="composer-toggle"
                      onClick={() => setComposerOpen(false)}
                    >
                      <MoreHorizontal size={16} />
                    </button>
                  </div>

                  <div className="composer-body">
                    <div className="composer-grid">
                      <div style={{ display: "grid", gap: 16 }}>
                        <input
                          value={storyTitle}
                          onChange={(e) => setStoryTitle(e.target.value)}
                          placeholder="Tiêu đề (Ví dụ: Mẹo dưỡng hoa hồng cành dài...)"
                          maxLength={120}
                        />
                        <textarea
                          value={storyContent}
                          onChange={(e) => setStoryContent(e.target.value)}
                          placeholder="Chia sẻ mẹo cắm hoa, chăm sóc hoặc tìm kiếm tư vấn..."
                          maxLength={4000}
                        />
                        <input
                          value={storyImage}
                          onChange={(e) => setStoryImage(e.target.value)}
                          placeholder="Dán đường dẫn (Link) hình ảnh của bạn vào đây (tùy chọn)..."
                        />
                      </div>

                      <div style={{ display: "grid", gap: 16, alignContent: "start" }}>
                        <select value={storyTag} onChange={(e) => setStoryTag(e.target.value)}>
                          {tags
                            .filter((t) => t !== "Tất cả")
                            .map((tag) => (
                              <option key={tag} value={tag}>
                                {tag}
                              </option>
                            ))}
                        </select>

                        <label
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            fontSize: 14,
                            color: "#4A4A4A",
                            cursor: "pointer",
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={storyAnonymous}
                            onChange={(e) => setStoryAnonymous(e.target.checked)}
                            style={{ accentColor: "#CBA153", width: 16, height: 16 }}
                          />
                          <span>Đăng ẩn danh</span>
                        </label>
                      </div>
                    </div>

                    <div className="composer-actions">
                      <div className="composer-left-actions">
                        <div className="action-pill">
                          <ImageIcon size={16} /> Thêm ảnh
                        </div>
                      </div>

                      <div className="composer-right-actions">
                        <button type="submit" className="mini-btn primary-btn">
                          <Send size={16} /> Đăng bài
                        </button>
                      </div>
                    </div>
                  </div>
                </motion.form>
              )}
            </AnimatePresence>

            <div className="feed-list">
              {allVisiblePosts.length === 0 ? (
                <div className="empty-state">
                  <CircleAlert size={48} />
                  <h3>Chưa có bài viết nào</h3>
                  <p>Trở thành người đầu tiên chia sẻ khoảnh khắc của bạn ngay hôm nay!</p>
                </div>
              ) : (
                allVisiblePosts.map((post, index) => (
                  <motion.div 
                    key={post.id} 
                    className="post-card"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: index * 0.05 }}
                  >
                    {post.image && (
                      <div className="post-hero">
                        <img src={post.image} alt={post.title} />
                        {post.tag && <div className="post-badge">{post.tag}</div>}
                      </div>
                    )}

                    <div className="post-body">
                      <div className="post-head">
                        <div className="author-row">
                          <img src={post.avatar} alt="avatar" className="avatar" />
                          <div>
                            <div className="author-name">{post.author}</div>
                            <div className="post-meta">{formatDate(post.createdAt)}</div>
                          </div>
                        </div>

                        {isAdmin && activeTab === "feed" && (
                          <button onClick={() => unpublishPost(post.id)} className="mini-btn">
                            <Trash2 size={16} /> Gỡ bài
                          </button>
                        )}
                      </div>

                      <h3 className="post-title">{post.title}</h3>
                      <p className="post-content">{post.content}</p>

                      {/* Admin Pending actions vs Normal Feed Actions */}
                      {activeTab === "pending" && isAdmin ? (
                        <div style={{ marginTop: 24, display: "flex", gap: 10, flexWrap: "wrap" }}>
                          <button onClick={() => approvePost(post.id)} className="mini-btn primary-btn">
                            <CheckCircle size={16} /> Duyệt bài
                          </button>
                          <button onClick={() => removePendingPost(post.id)} className="mini-btn">
                            <Trash2 size={16} /> Từ chối
                          </button>
                        </div>
                      ) : (
                        <>
                          <div className="post-stats">
                            <div className="post-counts">
                              <span>{post.likes} Thích</span>
                              <span>{post.hearts} Tim</span>
                              <span>{post.comments} Bình luận</span>
                              <span>{post.shares} Chia sẻ</span>
                            </div>

                            <div className="post-actions">
                              <button
                                className={`action-pill ${post.userReaction === "like" ? "active-like" : ""}`}
                                onClick={() => toggleReaction(post.id, "like")}
                              >
                                <ThumbsUp size={16} />
                              </button>

                              <button
                                className={`action-pill ${post.userReaction === "heart" ? "active-heart" : ""}`}
                                onClick={() => toggleReaction(post.id, "heart")}
                              >
                                <Heart size={16} />
                              </button>

                              <button
                                className="action-pill"
                                onClick={() => setSelectedPostId(selectedPostId === post.id ? null : post.id)}
                              >
                                <MessageCircle size={16} />
                              </button>

                              <button className="action-pill" onClick={() => handleShare(post)}>
                                <Share2 size={16} />
                              </button>

                              <button
                                className={`action-pill ${post.saved ? "active-save" : ""}`}
                                onClick={() => toggleSave(post.id)}
                              >
                                <Bookmark size={16} />
                              </button>
                            </div>
                          </div>

                          <AnimatePresence>
                            {selectedPostId === post.id && (
                              <motion.div
                                initial={{ opacity: 0, height: 0 }}
                                animate={{ opacity: 1, height: "auto" }}
                                exit={{ opacity: 0, height: 0 }}
                                className="comment-box"
                                style={{ overflow: "hidden" }}
                              >
                                <textarea
                                  placeholder="Viết bình luận của bạn..."
                                  value={commentDraft}
                                  onChange={(e) => setCommentDraft(e.target.value)}
                                />

                                <div style={{ display: "flex", justifyItems: "flex-end", marginTop: 12 }}>
                                  <button
                                    className="mini-btn primary-btn"
                                    onClick={() => handleComment(post.id)}
                                    style={{ marginLeft: "auto" }}
                                  >
                                    <Send size={16} /> Gửi bình luận
                                  </button>
                                </div>

                                <div className="comment-thread">
                                  {post.commentsList &&
                                    post.commentsList.map((c) => (
                                      <div key={c.id} className="comment-item">
                                        <div className="comment-author">
                                          {c.author}{" "}
                                          <span style={{ fontSize: 11, color: "#8c8c8c", fontWeight: "normal" }}>
                                            {" "}
                                            • {formatDate(c.createdAt)}
                                          </span>
                                        </div>
                                        <div className="comment-text">{c.text}</div>
                                      </div>
                                    ))}
                                </div>
                              </motion.div>
                            )}
                          </AnimatePresence>
                        </>
                      )}
                    </div>
                  </motion.div>
                ))
              )}
            </div>
          </motion.div>

          <motion.div 
            className="sidebar"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="sidebar-card">
              <h3 className="sidebar-title">Chủ đề nổi bật</h3>
              <div className="sidebar-list">
                {trendingTopics.map((t) => (
                  <div key={t.label} className="trend-row">
                    <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <TrendingUp size={16} color="#CBA153" /> {t.label}
                    </span>
                    <span style={{ color: "#8C8C8C", fontSize: 12 }}>{t.count} bài</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="sidebar-card">
              <h3 className="sidebar-title">Quy tắc cộng đồng</h3>
              <div className="guideline">
                {quickRules.map((r, i) => (
                  <div key={i} className="guide-item">
                    {r}
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}